 const modalTypes = {
  COMMUNITY_GUIDELINES: 'COMMUNITY_GUIDELINES',
  COMMUNITY_INVITES: 'COMMUNITY_INVITES',
  CONTACT_ADMINS: 'CONTACT_ADMINS',
  DELETE_POST: 'DELETE_POST',
  EDIT_BADGES: 'EDIT_BADGES',
  EMAIL_SUBSCRIBE_ALL_POSTS: 'EMAIL_SUBSCRIBE_ALL_POSTS',
  EMAIL_UNSUBSCRIBE_ALL_EMAILS: 'EMAIL_UNSUBSCRIBE_ALL_EMAILS',
  ENROLL_IN_PROGRAM: 'ENROLL_IN_PROGRAM',
  GUIDELINES_ADD: 'GUIDELINES_ADD',
  GUIDELINES_DELETE: 'GUIDELINES_DELETE',
  GUIDELINES_INFO: 'GUIDELINES_INFO',
  IFRAME: 'IFRAME',
  LOST_ACCESS_CODE: 'LOST_ACCESS_CODE',
  MARKETING_OPT_IN: 'MARKETING_OPT_IN',
  NEEDS_ASSESSMENT_TIPS: 'NEEDS_ASSESSMENT_TIPS',
  NEEDS_ASSESSMENT: 'NEEDS_ASSESSMENT',
  NHS_TAG_CONTENT: 'NHS_TAG_CONTENT',
  PRIVACY_REMINDER: 'PRIVACY_REMINDER',
  PROFILE_SURVEY: 'PROFILE_SURVEY',
  PROGRAM_COMPLETED: 'PROGRAM_COMPLETED',
  REMOVE_MEMBER_FROM_COMMUNITY: 'REMOVE_MEMBER_FROM_COMMUNITY',
  REPLY_IMAGE_DESCRIPTION: 'REPLY_IMAGE_DESCRIPTION',
  REPORT: 'REPORT',
  SAVE_POST: 'SAVE_POST',
  TAKE_PROFILE_SURVEY_ON_SIGNUP: 'TAKE_PROFILE_SURVEY_ON_SIGNUP',
  TAKE_PROFILE_SURVEY: 'TAKE_PROFILE_SURVEY',
};
export default modalTypes;

export type modalTypes = keyof typeof modalTypes;
